
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-rotate-ccw",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-rotate-ccw"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 4v6h6"}}),_c('path',{attrs:{"d":"M3.51 15a9 9 0 102.13-9.36L1 10"}})])
          )
        }
      }
    